var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "task-center-container" }, [_c('pt-button', { staticClass: "task-center-enter task-button", attrs: { "type": _vm.dark ? 'ghost' : 'filled', "theme": _vm.dark ? 'primary' : 'inverse', "size": "big", "mini": "", "icon": "" } }, [_c('ic-task')], 1), _vm._v(" "), _vm.badge ? _c('div', { staticClass: "task-badge" }) : _vm._e()], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };